import React, {Component} from 'react';
import {Modal, Table} from 'react-bootstrap';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';

var Config = require('../../../config');
var socket = "";

class ModalFolioSend extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleChange = this.handleChange.bind(this);

		this.state = {
			show: false,
			folios:[],
			copies:1
		}
	}

	componentDidMount(){
		this.props.onRef(this);

		socket= this.props.socket !== undefined && this.props.socket !== ""  ? this.props.socket : new WebSocket("wss://localhost:2018");

		if(socket.readyState !== socket.OPEN){
			//socket.send("initfp");
		}

		socket.onerror = (event)=> {
			console.log(event);
		};

		socket.onmessage = (event) => {
			var res = JSON.parse(event.data);
			if(res.Error === "No hay impresora configurada para imprimir")
				swal('¡Error!', res.Error, 'error');
		}	
	}

	componentWillUnmount(){
		this.props.onRef(null);
	}

	handleShow(id){
		
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'unit_delivered/get_folios?petition_id='+id, {
			method : 'get',			
			headers : new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
				'Content-Type': 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(result) {
					swal('¡Error!', result, 'error');
					return;
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({show:true, folios:response.res});
			}
		});
		
	}

	handleClose(){
		this.setState({show:false, folios:[]});
	}

	async printFolio(e, folio){
		e.preventDefault();
          
		var obj ={};
		obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
		obj.id = folio
		obj.file_type = "transfusion_unit";
		obj.nEtiqueta = [0];
		obj.copies = parseInt(this.state.copies);

		if(obj.copies >= 1){
			this.props.waiting.handleShow('Imprimiendo...');

			var type = await this.props.getDocumentType(obj.file_type);

			var document;
			if(type.print_type === 'template'){
				document = await this.props.printDocumentTemplate(obj, type.print_automatically);
			}else if(type.print_type === 'external'){
				document = await this.props.printDocumentExternal(obj, type.print_automatically);
			}

			if(document !== undefined){
				this.props.waiting.handleClose();
				this.setState({ show: false});
			}else{
				this.props.waiting.handleClose();
			}

			
		}else{
			swal('Error', 'Debe de enviar por lo menos una copia', 'error');
		}
	}

	handleChange(e){
		this.setState({[e.target.name]: e.target.value});
	}

	render(){
		const {t} = this.props;
		return (
			<Modal bsSize="sm" show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>Impresión de Folio</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
		        		<div className="col-xs-12">
		        			<div className="col-xs-12 col-sm-8 col-sm-offset-2">
				        		<Table responsive hover>
				        			<thead>
				        				<tr>
				        					<th>Folio</th>
				        				</tr>
				        			</thead>
				        			<tbody>
					        			{this.state.folios.map((s, i)=>{
						        			return <tr key={i}>
						        				<td>
						        					<a href="" onClick={(e)=>this.printFolio(e, s)}>
						        						{s}
						        					</a>
						        				</td>
						        			</tr>
						        		})}
					        		</tbody>
				        		</Table>
			        		</div>
			        		<div className="col-xs-12 col-sm-8 col-sm-offset-2">
				        		<div className="col-xs-12">
				        			<span className="span-min">Copias</span>
				        			<input type="number" className="form-control hour-input" value={this.state.copies}
				        				name="copies" id="copies" onChange={this.handleChange} min="1" />
				        		</div>
			        		</div>
		        		</div>
		        	</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	
		        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
		)
	}
}

export default translate('translations')(ModalFolioSend)